import React from "react";
import classNames from "classnames";
import InfoTooltip from "components/InfoTooltip";
import classes from "../styles.module.scss";

const PageInputContainer = ({ title, info, contentClass, containerStyle, children }) => {
    return (
        <div className={classes.pageContainer} style={containerStyle ? containerStyle : {}}>
            <p className={classes.pageHeader}>
                {title}
                {info && <InfoTooltip info={info} />}
            </p>
            <div className={classNames(classes.pageContent, contentClass)}>
                {children}
            </div>
        </div>
    );
}

export default PageInputContainer;